import React from "react"
import FormComposer from "@components/form/components/FormComposer"
import schema, { initialValues, withRecaptcha } from "./schema"
import { SectionTypes, FieldTypes } from "@components/form/common"

interface RegistrationFormProps {
  onSubmit: any
  errorMessage?: string
  isLoading: boolean
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  onSubmit,
  errorMessage,
  isLoading,
}) => {
  const productFields: any = [
    {
      type: FieldTypes.Text,
      name: "sku",
      label: "Model Number (SKU)*",
      placeholder: "Model Number (SKU)",
    },
    {
      type: FieldTypes.Text,
      name: "placeOfPurchase",
      label: "Place of Purchase*",
      placeholder: "Place of Purchase",
    },
    {
      type: FieldTypes.Text,
      name: "purchaseDate",
      label: "Purchase Date*",
      placeholder: "Purchase Date",
    },
    {
      type: FieldTypes.Text,
      name: "gearBrand",
      label: "Gear Brand",
      placeholder: "Gear Brand",
    },
    {
      type: FieldTypes.Text,
      name: "gearModel",
      label: "Gear Model",
      placeholder: "Gear Model",
    },
    {
      type: FieldTypes.Text,
      name: "gearYear",
      label: "Gear Year",
      placeholder: "Gear Year",
    },
  ]

  const useRecaptcha = process.env.NEXT_PUBLIC_VERCEL_ENV === "production"

  if (useRecaptcha) {
    productFields.push({
      type: FieldTypes.Recaptcha,
      name: "recaptcha",
      label: "Recaptcha",
    })
  }

  return (
    <FormComposer
      schema={useRecaptcha ? withRecaptcha : schema}
      formId="product-registration-form"
      initialValues={initialValues}
      sections={[
        {
          type: SectionTypes.Row,
          label: "Owner Information",
          fields: [
            {
              type: FieldTypes.Text,
              name: "firstName",
              label: "First Name*",
              placeholder: "First Name",
            },
            {
              type: FieldTypes.Text,
              name: "lastName",
              label: "Last Name*",
              placeholder: "Last Name",
            },
            {
              type: FieldTypes.Text,
              name: "email",
              label: "Email Address*",
              placeholder: "Email Address",
            },
            {
              type: FieldTypes.Text,
              name: "phoneNumber",
              label: "Phone Number*",
              placeholder: "Phone Number",
            },
            {
              type: FieldTypes.Text,
              name: "country",
              label: "Country*",
              placeholder: "Country",
            },
            {
              type: FieldTypes.Text,
              name: "address1",
              label: "Street Address*",
              placeholder: "Street Address",
            },
            {
              type: FieldTypes.Text,
              name: "address2",
              label: "Street Address 2",
              placeholder: "Street Address 2",
            },
            {
              type: FieldTypes.Text,
              name: "city",
              label: "City*",
              placeholder: "City",
            },
            {
              type: FieldTypes.Text,
              name: "stateProvince",
              label: "State or Province*",
              placeholder: "State or Province",
            },
            {
              type: FieldTypes.Text,
              name: "zipCode",
              label: "ZIP / Postal Code*",
              placeholder: "ZIP / Postal Code",
            },
          ],
        },
        {
          type: SectionTypes.Row,
          label: "Product information",
          fields: productFields,
        },
      ]}
      submitText="Submit Registration"
      onSubmit={onSubmit}
      errorMessage={errorMessage}
      isLoading={isLoading}
    />
  )
}

export default RegistrationForm
